import { Inject, Injectable } from '@angular/core';
import { Firestore, addDoc, collection, doc, setDoc } from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { DeckId } from '../models/deck.model';
import { Review, ReviewId, reviewConverter } from '../models/review.model';
import { UserId } from '../models/user.model';
import { FIRESTORE } from '../firebase-injection';

abstract class ReviewService {
  private firestore: Firestore;
  private reviewCollectionName: string;
  constructor(
    @Inject(FIRESTORE) firestore: Firestore,
    reviewCollectionName: string
  ) {
    this.firestore = firestore;
    this.reviewCollectionName = reviewCollectionName;
  }

  public updateReview(userId: UserId, deckId: DeckId, review: Review) {
    return this.addReviewToDeck(userId, deckId, review.id, review);
  }

  public addReviewToDeck(
    userId: UserId,
    deckId: DeckId,
    reviewId: ReviewId | undefined,
    review: Review
  ): Promise<ReviewId> {
    if (!reviewId) {
      const reviewRef = collection(
        this.firestore,
        'users',
        userId,
        'decks',
        deckId,
        this.reviewCollectionName
      ).withConverter(reviewConverter);
      return addDoc(reviewRef, review).then((ref) => {
        return <ReviewId>ref.id;
      });
    } else {
      const reviewRef = doc(
        this.firestore,
        'users',
        userId,
        'decks',
        deckId,
        this.reviewCollectionName,
        reviewId
      ).withConverter(reviewConverter);
      return setDoc(reviewRef, review).then(() => {
        return reviewId;
      });
    }
  }

  public getReviewsOfDeck(userId: UserId, deckId: DeckId) {
    const reviewsCol = collection(
      this.firestore,
      'users',
      userId,
      'decks',
      deckId,
      this.reviewCollectionName
    ).withConverter(reviewConverter);
    return collectionData(reviewsCol) as Observable<Review[]>;
  }
}

@Injectable({
  providedIn: 'root',
})
export class PrepareModeReviewService extends ReviewService {
  constructor(@Inject(FIRESTORE) firestore: Firestore) {
    super(firestore, 'preparationReviews');
  }
}

@Injectable({
  providedIn: 'root',
})
export class StudyModeReviewService extends ReviewService {
  constructor(@Inject(FIRESTORE) firestore: Firestore) {
    super(firestore, 'studyReviews');
  }
}
